import { render } from "./modifyProductDialog.vue?vue&type=template&id=75c45a81&scoped=true"
import script from "./modifyProductDialog.vue?vue&type=script&lang=js"
export * from "./modifyProductDialog.vue?vue&type=script&lang=js"

import "./modifyProductDialog.vue?vue&type=style&index=0&id=75c45a81&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75c45a81"]])

export default __exports__